import { Input, Select, TableProps } from "antd";
import SearchIcon from "../../../assets/icons/SearchIcon";
import SelectDownIcon from "../../../assets/icons/SelectDownIcon";
import TitleBar from "../../../components/common/TitleBar";
import CustomTable from "../../../components/ui/CustomTable";
import useTable from "../../../hooks/useTable";
import SidebarLayout from "../../../layouts/SidebarLayout";
import { countParPageSerialNumber } from "../../../utils/number";
import { valueOrNa } from "../../../utils/string";
import { addKeyInArray, selectSearchOption } from "../../../utils/utils";

type TableStatus = {
  status: string;
};

export default function MyProjectShiftList() {
  const {
    page,
    limit,
    filter,
    handleFilter,
    handleLimit,
    handlePagination,
    handleSearch,
  } = useTable<TableStatus>();

  const columns: TableProps<any>["columns"] = [
    {
      title: "#SL",
      align: "center",
      width: 60,
      render: (_, __, index) => countParPageSerialNumber(page, limit, index),
    },
    {
      title: "Shift Type",
      dataIndex: "shiftType",
      render: (val) => valueOrNa(val),
    },
    {
      title: "Date",
      align: "center",
      dataIndex: "date",
      render: (val) => valueOrNa(val),
    },
    {
      title: "Time",
      align: "center",
      dataIndex: "date",
      render: (val) => valueOrNa(val),
    },
    {
      title: "Duration",
      align: "center",
      dataIndex: "duration",
      render: (val) => valueOrNa(val),
    },
    {
      title: "Location",
      align: "center",
      dataIndex: "location",
      render: (val) => valueOrNa(val),
    },
    {
      title: "Price",
      align: "center",
      dataIndex: "price",
      render: (val) => (val ? <>৳ {val}</> : "৳ 0"),
    },
    {
      title: "Status",
      align: "center",
      dataIndex: "status",
      render: (val: string) => {
        if (!val) return "n/a";

        const statusMap = {
          pending: {
            bg: "bg-yellow-50",
            text: "text-yellow-500",
            label: "Pending",
          },
          confirmed: {
            bg: "bg-blue-50",
            text: "text-blue-500",
            label: "Confirmed",
          },
          complete: {
            bg: "bg-green-500/10",
            text: "text-green-600",
            label: "Complete",
          },
        };

        const status = statusMap[val.toLowerCase() as keyof typeof statusMap];

        if (!status) return valueOrNa(val);

        return (
          <div
            className={`px-2 py-0.5 ${status.bg} rounded-md inline-flex justify-center items-center gap-2.5`}
          >
            <div
              className={`justify-start ${status.text} text-sm font-medium font-['Inter'] leading-normal`}
            >
              {status.label}
            </div>
          </div>
        );
      },
    },
  ];

  return (
    <>
      <SidebarLayout title="My Projects">
        <TitleBar
          title="Shifts"
          backLink="/organization/my-projects/details/id"
        />

        <CustomTable
          loading={false}
          limit={limit}
          page={page}
          columns={columns}
          total={10}
          dataSource={addKeyInArray(rowData)}
          handleLimit={handleLimit}
          handlePagination={handlePagination}
          filterSection={
            <>
              <Input
                suffix={<SearchIcon />}
                placeholder="Search"
                style={{ minWidth: 170, maxWidth: 180 }}
                onChange={(val) => handleSearch(val)}
              />

              <Select
                allowClear
                showSearch
                placeholder="Status"
                filterOption={selectSearchOption}
                options={statusList}
                className="min-w-[90px]"
                suffixIcon={<SelectDownIcon />}
                rootClassName="icon-gray"
                value={filter.status}
                onChange={(val) => handleFilter("status", val)}
                popupMatchSelectWidth={120}
              />
            </>
          }
        />
      </SidebarLayout>
    </>
  );
}

const statusList = [
  {
    label: "Active",
    value: "Active",
    className: "bg-[#1DB4691F] text-[#11A75C]",
  },
  {
    label: "Inactive",
    value: "Inactive",
  },
];

const rowData = [
  {
    shiftType: "Morning",
    date: "2025-07-13",
    time: "9:00 AM - 12:00 PM",
    duration: "3h",
    location: "Dhaka",
    price: 1500,
    status: "pending",
  },
  {
    shiftType: "Evening",
    date: "2025-07-14",
    time: "4:00 PM - 7:00 PM",
    duration: "3h",
    location: "Chattogram",
    price: 1800,
    status: "confirmed",
  },
  {
    shiftType: "Evening",
    date: "2025-07-14",
    time: "4:00 PM - 7:00 PM",
    duration: "3h",
    location: "Chattogram",
    price: 1800,
    status: "complete",
  },
];
